/**
 * Testimonial Slider
 *
 * Enables client-side slider navigation within [data-testimonial-slider] elements.
 * Each slider holds:
 *   - N slide elements identified by [data-testimonial-slide]
 *   - A previous button identified by [data-testimonial-prev]
 *   - A next button identified by [data-testimonial-next]
 *   - A viewport container identified by [data-testimonial-viewport]
 *
 * The active slide is visible (no 'hidden' class), all others have 'hidden'.
 * Navigation wraps around (circular).
 */
(function () {
  function initSlider(slider) {
    var slides = Array.from(slider.querySelectorAll('[data-testimonial-slide]'));
    var prevBtn = slider.querySelector('[data-testimonial-prev]');
    var nextBtn = slider.querySelector('[data-testimonial-next]');
    if (!slides.length || !prevBtn || !nextBtn) return;
    var hasMultipleSlides = slides.length > 1;
    if (hasMultipleSlides) {
      prevBtn.classList.remove('hidden');
      nextBtn.classList.remove('hidden');
    } else {
      prevBtn.classList.add('hidden');
      nextBtn.classList.add('hidden');
    }
    // Determine initial active index (first slide without 'hidden', fallback to 0)
    var currentIndex = slides.findIndex(function (slide) {
      return !slide.classList.contains('hidden');
    });
    if (currentIndex === -1) currentIndex = 0;
    function showSlide(index) {
      slides.forEach(function (slide, i) {
        if (i === index) {
          slide.classList.remove('hidden');
        } else {
          slide.classList.add('hidden');
        }
      });
      currentIndex = index;
    }
    // Ensure consistent initial state
    showSlide(currentIndex);
    if (!hasMultipleSlides) return;
    prevBtn.addEventListener('click', function () {
      var newIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(newIndex);
    });
    nextBtn.addEventListener('click', function () {
      var newIndex = (currentIndex + 1) % slides.length;
      showSlide(newIndex);
    });
  }
  function init() {
    var sliders = document.querySelectorAll('[data-testimonial-slider]');
    sliders.forEach(initSlider);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
